import { ReferenceLink } from '../models/ReferenceLink';

export class ReferenceLinkMapper {
  mapFromPair(data: any): ReferenceLink | null {
    return Array.isArray(data) && data?.length === 2 && !!data[0] && !!data[1] ? new ReferenceLink(data[0], data[1]) : null;
  }

  mapFromKbLink(data: any): ReferenceLink[] {
    if (!data.kbLink) {
      return [];
    }

    try {
      const parsedContent: any[] = JSON.parse(data.kbLink);
      return parsedContent.map(({ title, url }) => new ReferenceLink(title, url));
    } catch {
      return [];
    }
  }
}
